letterAdjust.scale = 0.8;
var font = {
    "0": "M0 129l128 -129h369l135 137v788l-135 140h-369l-128 -132v-804zM198 177v710h236v-710h-236z",
    "1": "M0 805l25 22l47 32q28 19 76 24l21 2v-667q0 -50 -8 -94q-13 -62 -40 -124l287 1q-30 63 -41 117q-5 35 -5 82l1 865h-363v-260z",
    "2": "M0 0h682v234q-60 -38 -107 -44l-108 -13h-225v195l455 229v324l-137 140h-500v-221q54 25 110 36l327 5v-185l-451 -221l-13 -343q-12 -80 -33 -136z",
    "3": "M0 0h494l137 138v280l-112 114l112 117v276l-137 140h-494v-221q65 39 140 41l294 3v-267h-262v-178h262v-266h-220q-58 0 -120 20q-50 17 -94 44v-241z",
    "4": "M0 408l69 -138h321l-4 -67q-1 -48 -2 -61q-4 -35 -14 -61l-32 -81h292q-31 66 -38 100l-12 73l-3 97h118v224l-117 -66v637h-178zM178 427l211 362v-362h-211z",
    "5": "M0 1065q48 -189 48 -458v-134h426v-296h-198l-119 8l-104 31v-216h483l139 138v390l-100 99h-329v260h205l132 -14l77 -31l2 223h-662z",
    "6": "M0 129l127 -129h371l137 137v393l-97 97h-340v261h212l144 -18l57 -25l1 220h-518l-94 -98v-838zM198 177v293h238v-293h-238z",
    "7": "M0 1065l1 -217q75 40 152 40h281l-346 -888h219l325 861v204h-632z",
    "8": "M0 132l128 -132h369l137 138v281l-116 116l116 114v277l-137 139h-369l-128 -130v-286l114 -114l-114 -116v-287zM197 178v287h237v-287h-237zM197 607v282h237v-282h-237z",
    "9": "M0 538l96 -100h341v-261h-213l-145 19l-58 24l-1 -220h518l97 99v836l-129 130h-370l-136 -137v-390zM198 595v292h239v-292h-239z",
    "A": "M0 18q0 -18 32 -18h156q24 0 30 27l67 255h262l68 -255q4 -27 32 -27h173q28 0 28 18l-1 18l-320 1026l-24 3h-159l-23 -3l-6 -9zM309 427l62 267q15 59 40 210l97 -477h-199z",
    "B": "M0 1035l8 -1030l26 -5h263l197 18q80 21 136 104t56 180q0 98 -51 164t-146 93q158 73 158 233q0 130 -83 208q-41 38 -97 53l-182 12h-251l-26 -5zM203 170v295h77q94 0 137 -28q53 -35 53 -123q0 -86 -59 -120q-42 -24 -137 -24h-71zM203 625v284h82q153 0 153 -138 q0 -146 -146 -146h-89z",
    "C": "M0 545q0 270 116 404q100 116 254 116q129 0 237 -84l19 -27l-3 -12l-63 -111l-15 -9l-13 5l-30 21q-65 45 -118 45h-2q-171 0 -171 -316q0 -405 193 -405q63 0 131 53l14 6l15 -11l59 -104l3 -13q0 -22 -40 -47q-87 -56 -206 -56q-210 0 -305 177q-75 138 -75 368z",
    "D": "M0 1035l6 -1030l28 -5h322l126 20q247 69 247 522q0 287 -114 421q-49 58 -133 85l-126 17h-322q-34 0 -34 -30zM214 170v727h56q131 0 183.5 -74t52.5 -305q0 -207 -54 -285q-41 -63 -182 -63h-56z",
    "E": "M0 32l6 1028l28 5h518q31 0 31 -15l-1 -21l-30 -108q-7 -24 -34 -24h-304v-255h260l29 -4l5 -28v-104q0 -35 -34 -35h-260v-301h325q34 0 35 -34v-104l-7 -27l-28 -5l-533 5z",
    "F": "M0 32l5 1030l27 3h520q30 0 30 -15l-3 -21l-32 -108q-4 -24 -32 -24h-303v-255h262l26 -4l6 -28v-104q0 -35 -32 -35h-262v-439q0 -32 -33 -32h-147l-27 5z",
    "G": "M0 530q0 535 398 535q157 0 262 -76l11 -19l-1 -14l-56 -108l-10 -8l-12 2q-114 63 -184 63q-199 0 -199 -366q0 -165 25 -241q46 -132 176 -132q52 0 101 24v208h-111l-24 6q-6 4 -6 24v102q0 17 6 25l24 3l288 -3l7 -25v-417q0 -27 -35 -44q-111 -69 -265 -69 q-396 0 -395 530z",
    "H": "M0 32l5 1028l27 5h151q29 0 29 -30v-405h291v405l8 25l27 5h145l27 -5l5 -25l-5 -1030l-27 -5h-145l-27 5q-8 3 -8 27v439h-291v-439l-6 -27l-23 -5h-151l-27 5z",
    "I": "M0 32v89l5 27l27 5h85v762h-85l-27 3l-5 27v90l5 25l27 5h381q32 0 32 -30v-90l-4 -27l-28 -3h-83v-762h83q32 0 32 -32v-89l-4 -27l-28 -5h-381l-27 5z",
    "J": "M0 293q0 39 19 39h146q15 0 14 -19v-9q0 -136 93 -136q45 0 63 33q18 28 18 116v599h-209l-26 5l-6 25v88l6 24l26 7h386q29 0 29 -31v-688q0 -185 -66 -261q-75 -85 -216 -85q-200 0 -261 176q-16 48 -16 117z",
    "K": "M0 56v965q0 32 33 32h143q29 0 29 -32v-420l322 448q13 16 21 16h3l19 -4l111 -57l19 -21l-10 -20l-309 -412l362 -458l-21 -21l-129 -67h-7l-11 -5h-2l-22 16l-346 460v-420q0 -32 -29 -32h-143l-27 7z",
    "L": "M0 32l5 1028l27 5h147q35 0 35 -30v-843h365q31 0 31 -15v-12l-2 -6l-29 -132q-6 -27 -34 -27l-540 5z",
    "M": "M0 21l44 1014q2 30 33 30h154q26 0 34 -24l124 -392l44 -178l194 591l24 3h147q31 0 31 -30l49 -1014q1 -21 -30 -21h-140q-34 0 -35 32l-7 773l-158 -546q-10 -24 -37 -24h-91l-24 4l-13 23l-143 543l-11 -773q0 -32 -33 -32h-127q-33 0 -29 21z",
    "N": "M0 32l5 1028l27 5h124q29 0 44 -27l242 -456q52 -98 100 -239l-3 692l8 25l27 5h114l30 -3l2 -27l-2 -1030l-30 -5h-100q-28 0 -43 29l-268 506q-71 135 -98 218l-2 -748l-27 -5h-118l-27 5z",
    "O": "M0 549q0 -549 363 -549q370 0 370 549q0 516 -364 516q-199 0 -293 -167q-76 -134 -76 -349zM213 530v18q0 357 153 357q155 0 155 -370q0 -375 -154 -375h-1q-149 0 -153 370z",
    "P": "M0 1035l5 -1030l27 -5h151q31 0 31 32v395h78q160 0 257.5 94t97.5 253q0 146 -85 226q-71 65 -277 65l-280 -3zM214 601v306h59q99 0 131 -31q38 -32 38 -115q-1 -90 -42 -123q-44 -37 -145 -37h-41z",
    "Q": "M0 534q0 -534 365 -534l128 20q108 -118 152 -119l19 10l110 77l1 9l-16 22l-129 99q103 125 103 428v6q0 418 -243 494l-96 19h-57l-91 -19q-67 -21 -121 -74q-125 -126 -125 -438zM212 531q0 374 153 374t153 -369q0 -376 -152 -376h-1q-153 0 -153 371z",
    "R": "M0 1034l5 -1003l26 -4h139l27 4q4 5 4 26v395h81l213 -431q9 -21 22 -21l15 3l134 40q22 6 22 18l-6 22l-222 395q167 89 167 289q0 153 -89 231q-82 67 -261 67h-246l-26 -7zM201 612v297h60q94 0 127 -29.5t33 -112.5q0 -90 -43 -124q-37 -31 -132 -31h-45z",
    "S": "M0 89l5 15l47 127q3 15 13 15l15 -4q127 -70 230 -70q136 0 136 124q0 60 -35 93.5t-170 99.5q-112 54 -164 108q-71 72 -71 182q0 136 89.5 211t239.5 75q163 0 275 -71l15 -21l-6 -12l-52 -114l-16 -12l-12 5l-46 23q-75 38 -151 38q-136 0 -136 -107q0 -45 26.5 -71.5 t108.5 -66.5l81 -40q221 -108 221 -306q0 -144 -97 -229q-92 -81 -236 -81l-153 19q-87 21 -141 49z",
    "T": "M0 915v120q0 30 32 30h641q32 0 32 -15l-2 -21l-35 -122q-4 -27 -33 -27h-193l-4 -875l-27 -5h-152l-26 5l-4 27v848h-197q-32 0 -32 35z",
    "U": "M0 378v656l6 24l27 7h143l25 -7l5 -24v-657q0 -118 33 -165.5t120 -47.5q88 0 131 49q37 53 37 161v660q0 31 32 31h137l26 -7l5 -24v-656q0 -109 -24 -177q-22 -59 -91 -116q-102 -85 -266 -85q-191 0 -273 101q-73 91 -73 277z",
    "V": "M0 1019q0 11 25 15l175 31q13 0 18 -26l172 -833l185 826q11 28 18 28l8 -2h9l147 -19q27 -3 27 -18l-3 -17l-274 -979q-4 -25 -33 -25h-173q-29 0 -33 25z",
    "W": "M0 1016q0 16 27 21l134 28h18q13 0 19 -28l91 -499l28 -258l167 769l24 1h124l23 -1l11 -24l98 -476l45 -277l126 765q5 28 18 28h11l6 -3l126 -25q28 -7 28 -21l-2 -18l-222 -971q-7 -27 -34 -27h-135q-28 0 -34 27l-106 570l-25 198l-158 -768q-6 -27 -37 -27h-134 l-24 3l-10 24zM1136 61l11 22l3 2v-39z",
    "X": "M0 49v39l270 475l-258 439q0 15 28 22l165 36q9 0 20 -17l161 -336l40 112l104 224q10 22 24 22l16 -5l140 -39l19 -10l3 5v-20l-241 -436l285 -502q0 -16 -25 -21l-163 -37l-21 19l-183 371l-38 -81l-11 -16l-139 -270q-11 -20 -22 -20l-6 1h-12z",
    "Y": "M0 1002v22l15 10l12 1l158 30h15q13 0 24 -21l120 -263q26 -53 51 -119l13 -48l70 182l117 248q10 21 24 21h16l135 -30q26 -5 26 -20l-7 -22l-283 -563v-399l-4 -26l-27 -5h-146l-24 5l-8 26v401z",
    "Z": "M0 32v127l421 730h-372q-29 0 -29 18v10l29 121l12 24l22 3l556 -5l5 -25v-143l-409 -703h431q30 0 34 -16l-3 -14l-18 -130q-6 -29 -32 -29l-642 5z"
};
var font_size = 21,
    tracking = 1,
    panel_Hor_Adjustment = 1.5,
    font_Top_Adjustment = -12.5,
    middleSplitAdjustment = 0,
    small_Caps_Adjustment = {
        vertical: -220,
        horizontal: 0,
        scale_width: 0.1, // effects period
        scale_height: 0.1, // effects period
    },
    // Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
    colors = {
        characters: {
            home: [
                "#A8AAAD", // Letter Colour
            ],
            away: [
                "#0A0203", // Letter Colour
            ]
        },
        numbers: {
            home: [
                "#A8AAAD", // Number Colour
                "#231F20", // Number Stroke 1
                "#FFFFFF" // Number Stroke 2
            ],
            away: [
                "#0A0203", // Number Colour
                "#A8AAAD", // Number Stroke 1
                "#0A0203"  // Number Stroke 2
            ]
        }
    },
    outlines = {
        characters: {
            width: 1
        },
        numbers: {
            width: 4
        }
    },
    special_Character_Adjustments = {
        period: {
            vertical: 1.5, // this moves it up from the bottom
            horizontal: 3,
            scale_width: 12.5,
            scale_height: 12.5,
        },
        hyphen: {
            vertical: -6,
            horizontal: -5.5,
            scale_width: 0,
            scale_height: -3,
        },
        apostrophe: {
            vertical: 0.25, // this is backwards
            horizontal: -1,
            scale_width: 0,
            scale_height: 0,
        }
    },
    number_Adjustments = {
        top: 15,
        left: -4,
        width: 90,
        height: 80,
        middle_Space: 5,
    };
